import { useEffect } from 'react';

import { PostHogAnalytics } from './posthog/useEmitPostHogEvents';
import { initAnalytics, InitAnalyticsArgs } from './initAnalytics';

export type AnalyticsInitializerProps = InitAnalyticsArgs & {
  appName?: string;
  /**
   * When false, skips Mixpanel/heuristics init.
   * PostHog identify/capture uses `postHogOrganization` instead.
   */
  enabled?: boolean;
  /** Org context for PostHog identify/group; init runs even when `enabled` is false. */
  postHogOrganization?: { id: string; name: string };
};

export const AnalyticsInitializer = ({
  appName,
  enabled = true,
  email,
  orgID,
  orgName,
  enterpriseId,
  enterpriseName,
  postHogOrganization,
}: AnalyticsInitializerProps) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    initAnalytics({
      email,
      orgID,
      orgName,
      enterpriseId,
      enterpriseName,
    });
  }, [enabled, email, orgID, orgName, enterpriseId, enterpriseName]);

  const organization =
    postHogOrganization ?? (enabled ? { id: orgID, name: orgName } : undefined);

  return (
    <PostHogAnalytics
      appName={appName}
      user={{ email }}
      organization={organization}
    />
  );
};
